import { SettingPannelController } from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { dispatcher } from "@quest/base-core";

export class SettingPanelController extends SettingPannelController {

    /**
   * Override to update Jackpot Meter Values
   */
  protected onMaxBetPressUp(): void {
    super.onMaxBetPressUp();
    dispatcher.fireEvent(eventDispatchers.UPDATE_JACKPOT_METERS_VALUES);

  }

  /**
   * Override to update Jackpot Meters Values
   */
  protected onChangeStake(value: number): void {
    super.onChangeStake(value);
    dispatcher.fireEvent(eventDispatchers.UPDATE_JACKPOT_METERS_VALUES);
  }

}
